// extracted by mini-css-extract-plugin
export var mediaElement = "mockup-macbook-module--mediaElement--8f57f";
export var mockImage = "mockup-macbook-module--mockImage--7518b";
export var mockup = "mockup-macbook-module--mockup--0373b";